import React, { useState, useEffect } from "react";

import { AppBar, IconButton, Grid, Button, Toolbar } from "@material-ui/core";
import { useParams, useHistory } from "react-router-dom";

import GlobalApi from "./../../Global";
import swal from "@sweetalert/with-react";
import refresh_token from "./../../Global/refresh_token";
import Typography from "@material-ui/core/Typography";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import Modal from '@material-ui/core/Modal';
import moment from "moment";
import _ from "lodash";
import FormControl from '@material-ui/core/FormControl';
import Paper from "@material-ui/core/Paper";
import ArrowBackSharpIcon from "@material-ui/icons/ArrowBackSharp";
import "./print.css";
import OutlinedInput from '@material-ui/core/OutlinedInput';
import MenuItem from "@material-ui/core/MenuItem";
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import InputAdornment from '@material-ui/core/InputAdornment';
import { saveAs } from "file-saver";
import Menu from "@material-ui/core/Menu";
import useDimensions from "./../../Global/useDimensions";
import DarkButton from "./../../Global/DarkButton";
import Spinner from "./../../Global/Spinner";
import Colors from "./../../Global/colors";
import { useTranslation } from "react-i18next";

// React Multi Email components 
import { ReactMultiEmail, isEmail } from 'react-multi-email';
import 'react-multi-email/style.css';

//Others
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';


//Material UI Styles
import { makeStyles, withStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
}));




export default function InspectionPrint(props) {
  const classes = useStyles();
  const {t} = useTranslation();
  const [inspection, setInspection] = React.useState(null);
  const [template, setTemplate] = React.useState("");
  const [answers, setAnswers] = React.useState({});
  const [openModal, setOpenModal] = React.useState(false);
  const [btnLoader, setBtnLoader] = React.useState(false);
  const [emails, setEmails] = useState([]);
  const [emailCC, setEmailCC] = useState([]);
  const [errorObj,setErrorObj] = useState({})
  const [subject, setSubject] = useState("");
  const [loader, setLoader] = useState(false);  
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorEl2, setAnchorEl2] = useState(null);
   const [fetchedEmailTemp,setFetchedEmailTemp] = useState(null)
  const [emailBody, setEmailBody] = useState("<p>Hi</p><p>Please find the attached report with the findings.</p><p>Thanks</p><p>%auditor_name%</p>");
  let { id, isCompleted,pdf_url } = useParams();
  let { width } = useDimensions();
  let history = useHistory();
  React.useEffect(() => {
    getInspection();
    getTemplate()
  }, []);


  async function handleSubmit() {

    let localstorage = localStorage.getItem("UserData");
  var LocalStoragedata = JSON.parse(localstorage);
  let token = LocalStoragedata?.token;

  let errors = {};
  if (emails.length == 0) {
    swal(t("Warning"), t("Atleast One Email Required"), "warning");
  }else if (subject == "") {
    swal(t("Warning"), t("Subject is Required"), "warning");
  }

  if (emailBody == "") {
    swal(t("Warning"), t("Email Body is Required"), "warning");
  }
  setErrorObj(errors);


  if (Object.keys(errors).length === 0) {

    let data = {
      template_id:template,
      to_email:JSON.stringify(emails),
      cc_email:JSON.stringify(emailCC),
      subject:subject,
      body:emailBody
    }
    console.log('Save Data ****>>>>>>>>', data);
    if (fetchedEmailTemp == null) {
      setLoader(true);
      try {
        let template_email = await fetch(GlobalApi + '/EmailTemplate/create_email_template', {
          method: 'POST',
          headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data) 
        })
        let response = await template_email.json();
        console.log('Create Temp Response *****>>>>>>>>>>>>', response);
        if(response.status === 'Success'){
          setLoader(false);
          swal(t("Success"), t("Email Template has been updated"), "success");
        }
        else {
          setLoader(false);
          console.log('Something went wrong...!!!');
        }
      }
      catch (error) {
        console.log('Error ***>>>>>>>>', error);
        setLoader(false);
      }
    }else {
      try {
        setLoader(true);
        let template_email = await fetch(GlobalApi + '/EmailTemplate/edit_email_template', {
          method: 'POST',
          headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email_template_id :fetchedEmailTemp?.id,
            to_email:JSON.stringify(emails),
            cc_email:JSON.stringify(emailCC),
            subject:subject,
            body:emailBody
          })
        })
        let response = await template_email.json();
        console.log('Edit Temp Response *****>>>>>>>>>>>>', response);
        if(response.status === 'Success'){
          setLoader(false);
          swal(t("Success"), t("Email Template been updated"), "success");
        }
        else {
          setLoader(false);
          console.log('Something went wrong...!!!');
        }
      }
      catch (error) {
        console.log('Error ***>>>>>>>>', error);
        setLoader(false);
      }
    }
  }
}
async function getTemplate() {
  let localstorage = localStorage.getItem("UserData");
  var data = JSON.parse(localstorage);
  let token = data?.token;
  try {
    let params = {
      inspection_id: id
    }
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
      .join('&');

      console.log("query",query)

    let template_email = await fetch(GlobalApi + '/Inspection/get_insp_original_template?' + query, {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json',
      }
    })
    let response = await template_email.json();
    console.log('Get original Temp Response *****>>>>>>>>>>>>', response);
    setTemplate(response.template_id)
    getEmailTemplate(response.template_id);
  }
  catch (error) {
    console.log('Error ***>>>>', error);
  }
}
//get email template
async function getEmailTemplate(templateID) {
  let localstorage = localStorage.getItem("UserData");
  var data = JSON.parse(localstorage);
  let token = data?.token;
  try {
    let params = {
      template_id: templateID
    }
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
      .join('&');

      console.log("query",query)

    let template_email = await fetch(GlobalApi + '/EmailTemplate/get_email_template?' + query, {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json',
      }
    })
    let response = await template_email.json();
    console.log('Get Email Temp Response *****>>>>>>>>>>>>', response);
    if (response.data != null) {
      let emails = JSON.parse(response.data.to_email);
      let cc_emails = JSON.parse(response.data.cc_email);
      console.log('Email %%%%>>>', emails);
      console.log('Email CC%%%%>>>', cc_emails);
      setEmails(emails)
      setEmailCC(cc_emails)
      setSubject(response.data.subject)
      setEmailBody(response.data.body)
      // setAuthObj({
      //   email: emails[0],
      //   cc_email: cc_emails[0],
      //   subject: response.data.subject
      // })
      // setEmailTempData(response.data.body);
      setFetchedEmailTemp(response.data);
    }
  }
  catch (error) {
    console.log('Error ***>>>>', error);
  }
}

const handleSubject  = (text) =>{
  setSubject(text)
    }
  
    const editSubject = (data) =>{
      setSubject(subject.concat("%" + data + "%"))
    }
  
    const editEmail = (data) =>{
      setEmailBody(emailBody.concat("%" + data + "%"))
    }


  const handleOpen = () => {
    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
  };
  const handleClose2 = () => {
    setAnchorEl2(null);
  };

  const regenerateReport = async () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    try {
      let params = {
        inspection_id: id
      }
      let query = Object.keys(params)
        .map((k) => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
        .join('&');

        let request = await fetch(GlobalApi + '/Inspection/regenerate_inspection_pdf?' + query, {
          method: 'GET',
          headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
          },
        })
        let response = await request.json();
        console.log('Share Template Response *****>>>>>>>>', response);

        if(response.msg === 'success'){
          swal(t("Success"), t("Report has been Regenerated Successfully"), "success");
        }
        else if(response.msg === 'error'){
          swal(t("Error"), response.error, "error");
        }
    }catch (error) {
      console.log('Error ***>>>>', error);
    }
  }

  async function shareEmailTemplate() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;

    console.log("token11111",token)

    let param={
      inspection_id: id,
    }
    let query = Object.keys(param)
    .map((k) => encodeURIComponent(k) + '=' + encodeURIComponent(param[k]))
    .join('&');
   try {
    setLoader(true);
    let request = await fetch(GlobalApi + '/Inspection/share_inspection_report?' + query, {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json',
      },
    })
    let response = await request.json();
    console.log('Share Template Response *****>>>>>>>>', response);
    setLoader(false);
    if(response.msg === 'success'){
      swal(t("Success"), t("Report has been Emailed Successfully"), "success");
      handleClose()
    }
    else if(response.msg === 'error'){
      swal(t("Error"), response.error, "error");
    }
   } catch (error) {
    setLoader(false);
     console.log('Error >>>', error);
   }
  }

  const getInspection = () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      inspection_id: id,
      url: GlobalApi.replace("api", ""),
      
    };
    // console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Inspection/create-pdf-data?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log(response);
        if (response.status === "Success") {
          if (response.data) {
            console.log(response.data);
            setInspection(response.data);
            // console.log(response, "{}{}{}{}");
          }
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            getInspection();
          }
        }
      })
      .catch((error) => console.log(error.message));
    // console.log("op");
  };



  const handlePdfDownload = async () => {

    console.log("INSPECTION ID>>>>>>>>>>>>>>>>>>>>>", id)
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      inspection_id: id,
      user_id: data.user_id,
      url: GlobalApi.replace("api", ""),
    };
    let package_inquiry = {
      user_id: data.user_id,
      organization_id: data.organization_id,
    };

    console.log("PARAMS>>>>>>>>", params)
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
    console.log(query);

    let query1 = Object.keys(package_inquiry)
      .map(
        (k) =>
          encodeURIComponent(k) + "=" + encodeURIComponent(package_inquiry[k])
      )
      .join("&");
    let req = await fetch(GlobalApi + "/Package/get_user_license_details?" + query1, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    });

    let reqJson = await req.json();

    if (reqJson.package.pdf_request_status === "Request is Valid") {
      console.log("CREATE PDF NEW22_______________________________",isCompleted)

      if (isCompleted == "true" || pdf_url == "true") {
        let pdfData = await fetch(
          GlobalApi + "/Inspection/create-pdf?" + query,
          {
            method: "GET",
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            },
          }
        );
        let pdfDataJson = await pdfData.json();
        console.log("pdfData", pdfDataJson.pdf_url);
        window.open(pdfDataJson.pdf_url, '_blank');
        setBtnLoader(false);
      } else {

        let pdfData = await fetch(
          GlobalApi + "/Inspection/create-pdf?" + query,
          {
            method: "GET",
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            },
          }
        );

        const blob = await pdfData.blob();
        // setwaitForResponseWithOverlay( false );

        // const fileURL = URL.createObjectURL( blob );
    
  
        await saveAs(blob);
        setBtnLoader(false);
      }
     
    } else {

      swal(t("Warning"), reqJson.package.pdf_request_status, "warning");
      setBtnLoader(false);
    }
  };

  if (inspection === null) {
    return <Spinner />;
  }
  return <div style={{ overflow: "hidden", display: "flex", backgroundColor: Colors.globalColor9 }}>
      <Modal open={openModal} onClose={handleClose}>
        <div className="modal-size" style={{ position: "relative", maxWidth: "500px" }}>
          <ReactMultiEmail placeholder="To Email" emails={emails} onChange={(_emails) => {
              setEmails(_emails);
            }} validateEmail={(email) => {
              return isEmail(email); // return boolean
            }} getLabel={(email, index, removeEmail) => {
              return <div data-tag key={index}>
                  {email}
                  <span data-tag-handle onClick={() => removeEmail(index)}>
                    ×
                  </span>
                </div>;
            }} />
          <br />
          <ReactMultiEmail placeholder="Cc Email" emails={emailCC} onChange={(_emails) => {
              setEmailCC(_emails);
            }} validateEmail={(email) => {
              return isEmail(email); // return boolean
            }} getLabel={(email, index, removeEmail) => {
              return <div data-tag key={index}>
                  {email}
                  <span data-tag-handle onClick={() => removeEmail(index)}>
                    ×
                  </span>
                </div>;
            }} />
          <br />
          <FormControl variant="outlined" fullWidth size="small" className={classes.margin} autoComplete={"off"}>
            <OutlinedInput id="outlined-adornment-password" value={subject} onChange={(e) => handleSubject(e.target.value) // type={values.showPassword ? 'text' : 'password'}
              } placeholder="Subject" endAdornment={<InputAdornment position="end">
                  <IconButton aria-label="toggle password visibility" onClick={(e) => {
                      setAnchorEl(e.currentTarget);
                    }} edge="end">
                    <AddCircleOutlineIcon style={{ color: Colors.globalColor8 }} />
                  </IconButton>
                </InputAdornment>} />
          </FormControl>

          <Menu id="simple-menu" className="extraMenuBox" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
            <MenuItem style={{ cursor: "pointer" }} onClick={() => editSubject("location")}>
              Location
            </MenuItem>
            <MenuItem style={{ cursor: "pointer" }} onClick={() => editSubject("location_code")}>
              Location Code
            </MenuItem>
            <MenuItem style={{ cursor: "pointer" }} onClick={() => editSubject("score")}>
              Score
            </MenuItem>
            <MenuItem style={{ cursor: "pointer" }} onClick={() => editSubject("audit_date")}>
              Audit Date
            </MenuItem>
          </Menu>
          <br />

          <br />
          <div style={{ position: "relative" }}>
            <CKEditor editor={ClassicEditor} config={{ removePlugins: ["EasyImage", "ImageUpload", "MediaEmbed"] }} data={emailBody} onReady={(editor) => {
                // You can store the "editor" and use when it is needed.
                console.log("Editor is ready to use!", editor);
              }} onChange={(event, editor) => {
                const data = editor.getData();
                setEmailBody(data);
              }} onBlur={(event, editor) => {
                console.log("Blur.", editor);
              }} onFocus={(event, editor) => {
                console.log("Focus.", editor);
              }} />
            <IconButton style={{ position: "absolute", top: 35, right: 0 }} onClick={(e) => {
                setAnchorEl2(e.currentTarget);
              }}>
              <AddCircleOutlineIcon style={{ color: Colors.globalColor8 }} />
            </IconButton>

            <Menu id="simple-menu" className="extraMenuBox" anchorEl={anchorEl2} keepMounted open={Boolean(anchorEl2)} onClose={handleClose2}>
              <MenuItem style={{ cursor: "pointer" }} onClick={() => editEmail("executive_summary")}>
                Executive Summary
              </MenuItem>
              <MenuItem style={{ cursor: "pointer" }} onClick={() => editEmail("auditor_name")}>
                Auditor Name
              </MenuItem>
            </Menu>
          </div>

          <br />

          <div style={{ textAlign: "left" }}>
            <Button variant="contained" type="submit" className="addBtn" component="span" onClick={() => handleSubmit()}>
              {"Update"}
            </Button>
            &nbsp;
            <Button variant="contained" className="cancelBtn" onClick={() => handleClose()}>
              cancel
            </Button>
            &emsp;
            <Button variant="contained" className="addBtn" onClick={()=>shareEmailTemplate()}>
                share Report
              </Button>
            
          </div>
        </div>
      </Modal>

      <div className="" style={{ overflowY: "scroll", padding: "20px", width: "100%", backgroundColor: Colors.globalColor9 }}>
        <Grid container>
          <Grid xs={12} justifyContent="space-between" alignItems="right">
            <DarkButton style={{ margin: 5, backgroundColor: Colors.globalColor8 }} onClick={() => history.goBack()}>
              {"Go Back"}
            </DarkButton>
            <DarkButton style={{ margin: 5, backgroundColor: Colors.globalColor8 }} onClick={() => {
                setBtnLoader(true);
                handlePdfDownload();
              }} disabled={btnLoader}>
              {btnLoader ? "Downloading..." : " Export to Pdf"}
            </DarkButton>

            {isCompleted == "true" && <DarkButton style={{ margin: 5, backgroundColor: Colors.globalColor8 }} onClick={() => handleOpen()}>
                {"Share Report"}
              </DarkButton>}

              {isCompleted == "true" && <DarkButton style={{ margin: 5, backgroundColor: Colors.globalColor8 }} onClick={() => regenerateReport()}>
                {"Regenerate  Report"}
              </DarkButton>}
          </Grid>
        </Grid>
        <Grid container>
          {width >= 960 && <Grid item xs={12} md={4} className="sectionList">
              <Paper elevation={0} style={{ borderRadius: "10px", boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.19)", backgroundColor: "#f0f2f5", padding: 10, paddingTop: 20, paddingBottom: 20 }}>
                {inspection?.sections?.map((v) => {
                  console.log("VVVV____________________________VVVV", v);
                  return <Grid container style={{ textAlign: "left", padding: 5 }}>
                      <Grid item xs={9}>
                        <Typography className="textOne">{v.title}</Typography>
                      </Grid>
                      <Grid item xs={3} align="right">
                        <Typography className="textOne">
                          {v?.score ? v.score : 0}%
                        </Typography>
                      </Grid>
                    </Grid>;
                })}
              </Paper>
            </Grid>}
          <Grid item xs={12} md={8} className="sectionDetails" style={{ marginTop: "5px" }}>
            {inspection?.sections?.map((v) => {
              return <div style={{ backgroundColor: "#f0f2f5", margin: 5, paddingTop: 10, paddingBottom: 10, borderRadius: "10px", boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.19)" }}>
                  <Grid container style={{ padding: 5, paddingLeft: 10, paddingRight: 10 }}>
                    <Grid item xs={9} align="left">
                      <Typography className="textOne" variant="h5">
                        {v.title}
                      </Typography>
                    </Grid>
                    <Grid item xs={3} align="right">
                      <Typography className="textOne" variant="h5">
                        {v?.score ? v.score : 0}%
                      </Typography>
                    </Grid>
                  </Grid>
                  {v.CheckListInspections.map((che) => {
                    // if(che.answer.is_multiple=='true'){
                    //   alert(JSON.stringify(che.answer.multiple_images_arr))
                    // }
                    // console.log((che.data_type === "Photo" ||
                    // che.data_type === "Annotation") ? che.answer?.value : "op", che.answer, che.title, che)

                    return <Paper elevation={0} style={{ padding: 5, margin: 20, borderRadius: 20 } // variant="outlined"
                        }>
                        <Grid container style={{ padding: 5 }}>
                          <Grid item xs={12} align="left">
                            <Typography className="textOne" variant="p">
                              {che.title}
                            </Typography>
                          </Grid>
                          <Grid item xs={12} align="left">
                            {(che.data_type === "Photo" || che.data_type === "Anotation") && che.answer?.value !== "" ? <img src={`${che.answer.value}`} alt="image" style={{ maxWidth: 300 }} /> : <Typography variant="h6">
                                {che.data_type === "Global" ||
                                che.data_type === "Custom"
                                  ? che.custom_answers?.join(", ")
                                  : che.answer.value
                                  ? che.answer.value
                                  : "unanswered"}
                              </Typography>}

                            {che.answer.image !== null ? <img width="300px" src={`${che.answer.image}`} alt="image" /> : ""}
                            {che.answer.is_multiple == "true" ? <Grid item xs={12}>
                                <div style={{ flexDirection: "row", display: "flex", overflow: "auto" }}>
                                  {che.answer.multiple_images_arr.map(
                                    (img, index) => {
                                      return (
                                        <img
                                          width="200px"
                                          src={`${img}`}
                                          alt="image"
                                        />
                                      );
                                    }
                                  )}
                                </div>
                              </Grid> : ""}
                          </Grid>
                          <Grid item xs={12}>
                            {che.conditional.map((con) => {
                              return <Paper elevation={0} variant="outlined" style={{ padding: 5, borderRadius: 20 }}>
                                  <Grid container style={{ padding: 5 }}>
                                    <Grid item xs={12} align="left">
                                      <Typography className="textOne" variant="p">
                                        {con.title}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={12} align="left">
                                      {con.data_type === "Photo" || con.data_type === "Anotation" ? <img src={`${inspection?.anwser_obj[con.id].value}`} alt="image" style={{ maxWidth: 300 }} /> : <Typography variant="h6">
                                          {con.data_type === "Global" ||
                                          con.data_type === "Custom"
                                            ? con.custom_answers?.join(", ")
                                            : inspection?.anwser_obj[con.id]
                                                .value
                                            ? inspection?.anwser_obj[con.id]
                                                .value
                                            : "unanswered"}
                                        </Typography>}

                                      {inspection?.anwser_obj[con.id]?.image !== null ? <img width="300px" src={`${inspection?.anwser_obj[con.id]?.image}`} alt="image" /> : ""}
                                    </Grid>
                                  </Grid>
                                </Paper>;
                            })}
                          </Grid>
                        </Grid>
                      </Paper>;
                  })}
                </div>;
            })}

            {inspection?.InspectionComments?.length !== 0 ? <div style={{ backgroundColor: "#f0f0f0", margin: 5, paddingTop: 10, paddingBottom: 10 }}>
                <Grid container style={{ padding: 5, paddingLeft: 10, paddingRight: 10 }}>
                  <Grid item xs={12}>
                    <Typography className="textOne" variant="h5">
                      Inspection Comments
                    </Typography>
                  </Grid>

                  <Grid item xs={12}>
                    {inspection?.InspectionComments?.map((ic) => {
                      return <Paper elevation={0} variant="outlined" style={{ padding: 5, borderRadius: 20 }}>
                          <Grid container style={{ padding: 5 }}>
                            <Grid item xs={12} align="left">
                              <Typography className="textOne" variant="h5" style={{ color: ic.status === "Approved" ? "green" : "red" }}>
                                {ic.status} by {ic.User.first_name} {ic.User.last_name}
                              </Typography>
                              <Typography variant="p">
                                {ic.comment} at
                                {moment(ic.createdAt).format("DD MM yyyy")}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Paper>;
                    })}
                  </Grid>
                </Grid>
              </div> : ""}
          </Grid>
          <Grid item xs={3}>
            {/* List */}
          </Grid>
        </Grid>
      </div>
    </div>;
}